import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { DataWrapper } from "@/common/components/dataWrapper";
import Form from "@/common/components/form/Form";
import { Modal } from "@/common/components/modal";
import { Preview } from "@/common/components/preview";
import Table from "@/common/components/Table";
import {
  PRODUCT_URL,
  INVENTORY_URL,
  INVENTORY_STATS_URL,
  BatchInventory_URL,
  BatchProduct_URL,
  Prodcut_packaging_type,
} from "@/common/constants";
import {
  ModalFormWrapper,
  ModalPreviewWrapper,
  ModalWrapper,
} from "@/common/elements";
import { KeyValueObj } from "@/common/types";
import { useApiCallHandling } from "@/hooks/useApiCallHandling";
import { useAuthDetails } from "@/hooks/useAuthDetails";
import useAxiosCall from "@/hooks/useAxiosCall";
import { Barchart } from "../common/Barchart";
import { barOptions } from "../common/Data";
import {
  getBarchartData,
  getCardDetails,
  getRecentOrderTableData,
  ICardDetails,
  InventoryFilterOptions,
  inventoryForm,
  tableHeaders,
  tableHeadersShort,
  tableKeys,
  tableKeysShort,
} from "./subs/data";
import { AddInventoryWrapper } from "./subs/style";
import { StatCard } from "./subs/StatCard";
import { PageTitleNavs } from "@/common/components/page-title-navs";
import { Button } from "@/common/components/button";
import { formatToNaira, toParamsFormat } from "@/common/utils/general";
import useQuery from "@/hooks/useQuery";
import { PageSkeletonLoader } from "@/common/components/skeleton/page-skeleton";
import { ECompanyType } from "@/types/enum";
import { ActionPopup } from "@/common/components/action-popup";
import { usePositioning } from "@/hooks/usePositioning";
import { ProductFactory } from "../common/product-factory";
import FileUpload from "./batch/fileUploader";
import PreviewInventory from "./batch/preview";
import InventoryDetails from "./preview";

export interface IAddInventoryProps {}

export function AddInventory(_: IAddInventoryProps) {
  //STATES
  const [modalTitle, setModalTitle] = useState("");
  const [modalSubtitle, setModalSubtitle] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [stage, setStage] = useState("inventory");
  const [retry, setRetry] = useState(0);
  const [actualInventoryForm, setActualInventoryForm] = useState<any[]>([]);
  const [batchInventoryForm, setBatchInventoryForm] = useState<any[]>([]);
  const [editForm, setEditForm] = useState<any[]>([]);
  const [inventories, setInventories] = useState<KeyValueObj[]>([]);
  const [previewData, setPreviewData] = useState<any[]>([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [formValues, setFormValues] = useState<KeyValueObj>({});
  const [tableData, setTableData] = useState<any[]>([]);
  const [currentInventoryId, setCurrentInventoryId] = useState("");
  const [, setShowActions] = useState(false);
  const [, setDisableActionButtons] = useState(false);
  const [, setCurrentInventoryLoadingButton] = useState("");
  const [showInventoryOptions, setShowInventoryOptions] = useState(false);
  const [productType, setProductType] = useState("");
  const [addMore, setAddMore] = useState(false);
  const [openBatchUpload, setOpenBatchUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [step, setStep] = useState<"form" | "preview">("form");
  const [page, __setPage] = useState(1);
  const [perPage, __setPerPage] = useState(25);

  //HOOKES
  const [
    getInventories,
    inventoriesFetched,
    inventoriesError,
    inventoriesLoading,
  ] = useAxiosCall();

  const { data: inventoryMetrics, loading } = useQuery(INVENTORY_STATS_URL);
  const apiCall = useApiCallHandling();
  const [searchParams] = useSearchParams();
  const { companyType } = useAuthDetails();
  // ********* Hooks ***********
  const [setPosition, position] = usePositioning();

  const [BatchformData, setBatchFormData] = useState<KeyValueObj>({});
  const [singleBatchProduct_ID, setSingleBatchProduct_id] =
    useState<KeyValueObj>({});
  const [selectedInventory, setSelectedInventory] = useState<KeyValueObj>();

  const [getProducts, productsFetched, productsError, productsLoading] =
    useAxiosCall();
  const { data: BatchInvertoryData } = useQuery(BatchProduct_URL);

  const GetSinglePackaging_type = useQuery(
    Prodcut_packaging_type +
      `/${singleBatchProduct_ID?.product_id}/package-types`,
    Object?.keys(singleBatchProduct_ID)?.length > 0,
  );

  const GetPackaging_type = useQuery(
    Prodcut_packaging_type + `/${BatchformData?.product_id}/package-types`,
    Object?.keys(BatchformData)?.length > 0,
  );

  //FETCHING PAGE LOAD DATA
  useEffect(() => {
    getProducts({
      method: "GET",
      url: PRODUCT_URL + "?status=approved",
    });
    getInventories({
      method: "GET",
      url: INVENTORY_URL,
    });
  }, [retry]);

  //HANDLING INVENTORY TABLE
  useEffect(() => {
    inventoriesFetched && setInventories(inventoriesFetched);
  }, [inventoriesFetched]);

  useEffect(() => {
    const inventoryTable =
      inventories.length > 0 &&
      inventories
        .reverse()
        .map((inventory: (typeof inventoriesFetched)[0]) => ({
          name: {
            value: inventory?.product?.brand_name,
            type: "string",
          },

          unit: {
            value: inventory?.product?.form,
            type: "string",
          },
          strength: {
            type: "string",
            value: `${inventory?.product?.strength}${
              inventory?.product?.strength_unit === "milligrams" ? "mg" : "g"
            }`,
          },
          storage: {
            value: inventory?.product.storage_requirement,
            type: "string",
          },

          quantity: {
            value: inventory?.quantity_in_stock,
            type: "string",
          },
          minLevel: {
            value: inventory?.reorder_level,
            type: "string",
          },
          supply: {
            value: inventory?.quantity_sold,
            type: "string",
          },
          selling_price: {
            value: formatToNaira(inventory?.selling_price_per_unit),
            type: "string",
          },
          id: inventory?.id,
        }));

    inventoryTable && setTableData(inventoryTable);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventories]);

  useEffect(() => {
    const options: KeyValueObj[] = [];
    productsFetched?.forEach((product: KeyValueObj) => {
      options.push({
        id: product.id,
        title: `${product.atc_code?.readable_name}(${product.brand_name}) - ${
          product?.strength
        }${product?.strength_unit === "grams" ? "mg" : "g"}`,
      });
    });

    const options2: KeyValueObj[] = [];
    BatchInvertoryData?.forEach((product: KeyValueObj) => {
      options2.push({
        id: product.id,
        title: product.name,
      });
    });

    const SimplepackagingType: KeyValueObj[] = Object.entries(
      GetSinglePackaging_type?.data || {},
    ).map(([__key, value]) => ({
      id: value as string,
      title: value as string,
    }));

    const packagingType: KeyValueObj[] = [];
    Object.entries(GetPackaging_type?.data || {}).forEach(([__key, value]) => {
      packagingType.push({
        id: value as string, //this is bcox the value is what we will be sending to the backend, and the key is just for display
        title: value as string,
      });
    });

    setActualInventoryForm([
      {
        inputType: "selectInput",
        prompt: "Select the product",
        name: "product_id",
        placeholder: "Select a product from the list",
        fullWidth: false,
        returnId: true,
        options: options?.length > 0 ? options : [], //This check is very neccesary => if (options.length > 0)
      },
      {
        inputType: "selectInput",
        prompt: "Select Packaging type",
        name: "package_type",
        placeholder: "Packaging Type",
        returnId: true,
        options: SimplepackagingType,
      },
      ...inventoryForm,
    ]);

    setBatchInventoryForm([
      {
        inputType: "selectInput",
        prompt: "Select the product",
        name: "product_id",
        placeholder: "Select a product",
        returnId: true,
        options: options,
      },

      {
        inputType: "selectInput",
        prompt: "Select Packaging type",
        name: "package_type",
        placeholder: "Packaging Type",
        returnId: true,
        options: packagingType,
      },
    ]);

    if (searchParams.get("new") === "true" && !productsLoading) {
      setShowModal(true);
      setModalTitle("Add Inventory");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsFetched, productsError, productsLoading, BatchInvertoryData]);

  //FUNCTIONS

  function handleProductTypeSelected(type: string) {
    setProductType(type);
    if (type === "single_update") {
      setShowModal(true);
      setModalTitle("Add Inventory");
      setStage("inventory");
    }

    if (type === "bulk_upload") {
      setShowModal(false);
      setOpenBatchUpload(true);
    }
    setShowInventoryOptions(false);
  }

  const InvertoryTypeActions = [
    {
      label: "Single Upload",
      action: () => handleProductTypeSelected("single_update"),
    },
    {
      label: "Bulk Upload",
      action: () => handleProductTypeSelected("bulk_upload"),
    },
  ];

  function handleAddInventory(e: any) {
    setPosition(e);
    setShowInventoryOptions(true);
  }

  // @ts-ignore
  const onProductSelect: any = async (
    latestInput: string,
    // @ts-ignore
    name: string,
    // @ts-ignore
    updateValidity: (name: string, validity: boolean) => void,
    // @ts-ignore
    setFormValues: Dispatch<SetStateAction<KeyValueObj>>,
  ) => {
    //replace the package_type with loading state
    setActualInventoryForm((prev: any) => {
      const packageInput = {
        inputType: "number",
        prompt: "Quantity",
        name: "quantity_received",
        fullWidth: false,
        readOnly: true,
        loadingState: true,
        placeholder: "Loading packages",
      };

      const index = prev.findIndex(
        (inv: any) => inv.name === "quantity_received",
      );
      prev.splice(index, 1, packageInput);
      return prev.slice();
    });

    //get the product details
    const [product] = productsFetched.filter(
      (product: any) => product.id === latestInput,
    );

    let currentReorderLevel = 0;

    //fetch the inventory details
    const atcCode = product?.atc_code?.id;
    const brand = product?.brand_name;

    await apiCall(
      `api/v1/company/inventories/${atcCode}/${brand}`,
      "GET",
      {},
      (data) => {
        if (data.length > 0) {
          currentReorderLevel = data[data.length - 1].reorder_level;
        }
      },
      (err) => {
        console.log(err);
      },
      () => {},
    );

    //await sleep(500);

    setActualInventoryForm((prev: any) => {
      //set the package type with correct options,
      const packageInput = {
        inputType: "number",
        prompt: `Quantity (${product.tertiary_packaging})`,
        name: "quantity_received",
        placeholder: "Type the quantity to be added",
        fullWidth: false,
        rules: {
          aboveZero: {
            expectedValue: true,
            errorMessage: "Value must be greater than 0",
          },
        },
      };

      const index = prev.findIndex(
        (inv: any) => inv.name === "quantity_received",
      );

      prev.splice(index, 1, packageInput);

      //set the reorder level and put the initial value of the reorder level
      //check if it already exist first and replace it
      const reorderIndex = prev.findIndex(
        (inv: KeyValueObj) => inv.name === "reorder_level",
      );

      const reorderInput = {
        inputType: "number",
        prompt: "Enter Reorder level",
        name: "reorder_level",
        placeholder: "Type the quantity that will trigger reorder",
        fullWidth: false,
        initialValue: currentReorderLevel,
        rules: {
          notNegative: {
            expectedValue: true,
            errorMessage: "Value must be non negative",
          },
        },
      };

      if (reorderIndex === -1) {
        prev.push(reorderInput);
      } else {
        prev.splice(reorderIndex, 1, reorderInput);
      }

      return prev.slice();
    });
  };

  // const onFetchPackagingType: any = async () => {};

  function onFormContinue(formValues: KeyValueObj) {
    const formPreviewData: KeyValueObj[] = [];
    Object.keys(formValues).forEach((formKey: any) => {
      formPreviewData.push({
        name: formKey,
        value: formValues[formKey],
      });
    });

    setFormValues(formValues);
    setPreviewData(formPreviewData);
    setModalTitle("Review your Inventory");
    setModalSubtitle("");
    setStage("inventory-preview");
  }

  function onPreviewBack() {
    setModalTitle("Add Inventory");
    setStage("inventory");
  }

  function buildFormData(formValues: KeyValueObj): FormData {
    const formData = new FormData();
    //add form values
    Object.keys(formValues).forEach((formKey: string) => {
      //remove the additional info on the packaging
      if (formKey === "package_type") {
        const value = formValues[formKey].split(" ")[0];
        formData.append(formKey, value);
      } else {
        formData.append(formKey, formValues[formKey]);
      }
    });
    return formData;
  }

  async function onPreviewSubmit() {
    setSubmitLoading(true);
    const formData = buildFormData(formValues);
    const data = await apiCall(
      INVENTORY_URL,
      "POST",
      formData,
      () => {
        setFormValues({});
        setStage("inventory");
        setShowModal(false);
      },
      () => {},
      () => {
        setSubmitLoading(false);
      },
    );
    data && setInventories([data, ...inventories]);
  }

  // ************** filter batch data ************
  const selectedProduct = BatchInvertoryData?.find(
    (item: any) => item.id === BatchformData?.product_id,
  );

  async function onBatchSubmit() {
    setSubmitLoading(true);
    const formData = new FormData();
    // Append form fields
    Object.entries(BatchformData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, String(value));
      }
    });

    // Append extra data
    formData.append("product_name", selectedProduct?.name ?? "");

    // Append file
    if (selectedFile) {
      formData.append("file", selectedFile);
    }

    const data = await apiCall(
      BatchInventory_URL,
      "POST",
      formData,
      () => {
        setFormValues({});
        setShowModal(false);
        setOpenBatchUpload(false);
      },
      () => {},
      () => {
        setSubmitLoading(false);
      },
    );
    data;
  }

  function resetEditStates() {
    setCurrentInventoryId("");
    setDisableActionButtons(false);
    setCurrentInventoryLoadingButton("");
  }

  function onActionButtonClicked(buttonName: string, row: KeyValueObj) {
    setCurrentInventoryLoadingButton(buttonName);
    setCurrentInventoryId(row?.id);
    setDisableActionButtons(true);

    switch (buttonName) {
      case "view":
        // onViewInventory(row?.id);  //commenting this out because... i really dont understand the function well.
        handleViewInventory(row.id);

        break;
      //reset states
      case "delete":
        apiCall(
          INVENTORY_URL + `/${row?.id}`,
          "DELETE",
          {},
          // @ts-ignore
          (data: KeyValueObj) => {
            //if succesful, remove the current id from list
            setShowActions(false);
            const filteredInventories = inventories.filter(
              (inv: KeyValueObj) => inv.id !== currentInventoryId,
            );
            filteredInventories && setInventories(filteredInventories);
          },
          (error: KeyValueObj) => {
            console.log(error);
          },
          () => {
            resetEditStates();
          },
        );

        break;

      case "edit":
        onEditInventory(row?.id);
        break;

      default:
        break;
    }
  }

  const handleViewInventory = (id: string) => {
    const inventory = inventories.find((item) => item.id === id);
    if (!inventory) {
      console.error("Inventory not found");
      return;
    }

    setSelectedInventory(inventory);
    setShowModal(true);
    setShowActions(false);
    setStage("inventory-view");
    setModalTitle("View Inventory Details");
  };

  function onEditInventory(id: string) {
    const inventory = inventories.find(
      (inventory: KeyValueObj) => inventory.id === id,
    );
    let newInventoyForm: any = [];
    if (
      companyType?.toLowerCase() === "manufacturer" ||
      companyType?.toLowerCase() === "importer"
    ) {
      newInventoyForm = actualInventoryForm.map((formInput: KeyValueObj) => {
        if (formInput.name === "product_id") {
          return {
            ...formInput,
            inputType: "input",
            prompt: "Product",
            readOnly: true,
            initialValue:
              inventory?.product?.brand_name +
              " - " +
              inventory?.product?.strength +
              inventory?.product?.strength_unit,
          };
        } else if (formInput.name === "package_type") {
          return {
            ...formInput,
            initialValue: inventory?.package_type,
            options: [
              {
                id: 1,
                title:
                  inventory?.product.primary_packaging + " (Primary Packaging)",
              },
              {
                id: 2,
                title:
                  inventory?.product.secondary_packaging +
                  " (Secondary Packaging)",
              },
              {
                id: 3,
                title:
                  inventory?.product.tertiary_packaging +
                  " (Tertiary Packaging)",
              },
            ],
          };
        } else {
          return {
            ...formInput,
            initialValue: inventory && inventory[formInput.name],
          };
        }
      });
    } else {
      newInventoyForm = actualInventoryForm.map((formInput: KeyValueObj) => {
        if (formInput.name === "product_id") {
          return {
            ...formInput,
            inputType: "input",
            prompt: "Product",
            readOnly: true,
            initialValue:
              inventory?.product?.brand_name +
              " - " +
              inventory?.product?.strength +
              inventory?.product?.strength_unit,
          };
        } else if (formInput.name === "selling_price_per_unit") {
          return {
            ...formInput,
            initialValue: inventory && inventory[formInput.name],
          };
        } else {
          return {
            ...formInput,
            initialValue: inventory && inventory[formInput.name],
            readOnly: true,
            inputType: "input",
          };
        }
      });
    }

    setShowActions(false);
    setEditForm(newInventoyForm);
    setShowModal(true);
    setModalTitle("Edit Inventory");
    setStage("inventory-edit");
  }

  function onEditInventoryContinue(formValues: KeyValueObj) {
    const formPreviewData: KeyValueObj[] = [];
    Object.keys(formValues).forEach((formKey: any) => {
      formPreviewData.push({
        name: formKey === "product_id" ? "Product" : formKey,
        value: formValues[formKey],
      });
    });

    setFormValues(formValues);
    setPreviewData(formPreviewData);
    setModalTitle("Review your Edited Inventory");
    setModalSubtitle("");
    setStage("inventory-edit-preview");
  }

  function onEditPreviewSubmit() {
    setSubmitLoading(true);
    const formData = buildFormData(formValues);
    apiCall(
      `${INVENTORY_URL}/${currentInventoryId}`,
      "PUT",
      formData,
      (data: KeyValueObj) => {
        setInventories((prev: KeyValueObj[]) => {
          const index = prev.findIndex(
            (inventory: KeyValueObj) => inventory.id === currentInventoryId,
          );
          prev[index] = data;
          return prev.slice();
        });
        setShowModal(false);
        setFormValues({});
      },
      // @ts-ignore
      (error: KeyValueObj) => {},
      () => {
        setSubmitLoading(false);
        resetEditStates();
      },
    );
  }

  function onEditPreviewBack() {
    setModalTitle("Edit Inventory");
    setModalSubtitle("");
    setStage("inventory-edit");
  }

  function onCloseModal() {
    setShowModal(false);
    resetEditStates();
  }

  function CloseBatuploadModal() {
    setStep("form");
    setSelectedFile(null);
    setOpenBatchUpload(false);
  }

  // @ts-ignore
  function onViewInventory(id: string) {
    const previewDataInner: KeyValueObj[] = [];
    const inventory = inventories.find(
      (inventoryInner: KeyValueObj) => inventoryInner.id === id,
    );

    const product = inventory?.product;

    //preparing product data for preview;
    const productData: KeyValueObj[] = [];
    Object.keys(product).forEach((productItemKey: string) => {
      //we need to go into the images and push them individually
      if (productItemKey === "images") {
        product[productItemKey]?.forEach(
          (imageItem: KeyValueObj, index: number) => {
            productData.push({
              name: "image_" + index,
              value: imageItem?.url,
              type: "imageUrl",
            });
          },
        );
      }
      //we also need to not include the ids in the list
      else if (
        productItemKey !== "id" &&
        productItemKey !== "manufacturer_id" &&
        productItemKey !== "atc_code_id" &&
        productItemKey !== "name"
      ) {
        productData.push({
          name: productItemKey,
          value: product[productItemKey],
        });
      }
    });

    //Preparing inventory data for view;

    const inventoryData: KeyValueObj[] = [];
    inventory &&
      Object.keys(inventory).forEach((invKey: string) => {
        if (
          invKey !== "product" &&
          invKey !== "id" &&
          invKey !== "owner" &&
          invKey !== "supplier"
        ) {
          inventoryData.push({
            name: invKey,
            value: inventory[invKey],
          });
        }
      });

    previewDataInner.push({
      type: "category",
      name: "Product Details",
      value: productData,
    });
    previewDataInner.push({
      type: "category",
      name: "Inventory Details",
      value: inventoryData,
    });

    setPreviewData(previewDataInner);
    setShowModal(true);
    setStage("inventory-view");
    setShowActions(false);
    setModalTitle("Inventory Details");
    resetEditStates();
  }

  const showDropdown = () => {
    const actions = {
      view: (row: KeyValueObj) => onActionButtonClicked("view", row),
      edit: (row: KeyValueObj) => onActionButtonClicked("edit", row),
      delete: (row: KeyValueObj) => onActionButtonClicked("delete", row),
    };

    const companyActionsMap: Record<string, string[]> = {
      [ECompanyType.MANUFACTURER.toLowerCase()]: ["view", "edit", "delete"],
      [ECompanyType.DISTRIBUTOR.toLowerCase()]: ["view"],
    };

    const selectedActions = companyActionsMap[companyType.toLowerCase()] || [];

    return selectedActions.map((key) => ({
      label: key,
      action: actions[key as keyof typeof actions],
    }));
  };

  if (loading) return <PageSkeletonLoader />;

  //  ************** Batch upload functions ***************
  const handleExternalUpdate = (name: string, value: any) => {
    setBatchFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSingleProduceChange = (name: string, value: any) => {
    setSingleBatchProduct_id((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // useEffect(() => {
  //   tableData && setTableData(tableData);
  // }, [tableData]);

  // ================ handling search and filters ============
  function updateTableData(queryParams: string) {
    // const params = new URLSearchParams(queryParams).toString();
    apiCall(
      `${INVENTORY_URL}${queryParams}`,
      "GET",
      {},
      (data) => {
        const inventoryTable = (data || [])
          .slice() // prevent mutating original
          .reverse()
          .map((inventory: (typeof inventoriesFetched)[0]) => ({
            name: {
              value: inventory?.product?.brand_name,
              type: "string",
            },

            unit: {
              value: inventory?.product?.form,
              type: "string",
            },
            strength: {
              type: "string",
              value: `${inventory?.product?.strength}${
                inventory?.product?.strength_unit === "milligrams" ? "mg" : "g"
              }`,
            },
            storage: {
              value: inventory?.product.storage_requirement,
              type: "string",
            },

            quantity: {
              value: inventory?.quantity_in_stock,
              type: "string",
            },
            minLevel: {
              value: inventory?.reorder_level,
              type: "string",
            },
            supply: {
              value: inventory?.quantity_sold,
              type: "string",
            },
            selling_price: {
              value: formatToNaira(inventory?.selling_price_per_unit),
              type: "string",
            },
            id: inventory?.id,
          }));

        inventoryTable && setTableData(inventoryTable);
      },
      () => {},
      () => {},
      { dontNotifyOnSucess: true },
    );
  }

  function handleSearch(value: string) {
    let values = { page, perPage, search_term: value };
    let params = toParamsFormat(values);
    updateTableData(params);
  }

  function handleOrderFilter(values: KeyValueObj) {
    values["page"] = page;
    values["per_page"] = perPage;
    const params = toParamsFormat(values);
    updateTableData(params);
  }
  return (
    <>
      <AddInventoryWrapper>
        <PageTitleNavs
          title="Inventories"
          backLink="#"
          bcrumbs={[{ title: "Inventories", link: "#" }]}
        />
        <ProductFactory
          open={addMore}
          close={() => setAddMore(false)}
          productType={productType}
        />{" "}
        <div className="stats-wrapper">
          <div className="cards-wrapper">
            {getCardDetails(inventoryMetrics?.metrics)?.map(
              (card: ICardDetails, idx: number) => (
                <StatCard
                  key={idx}
                  title={card.title}
                  value={card.value}
                  imageUrl={card.imageUrl}
                  bg={card.bg}
                />
              ),
            )}
          </div>

          <div className="inventories ">
            <div className="controls">
              {(companyType?.toLowerCase() === "manufacturer" ||
                companyType?.toLowerCase() === "importer") && (
                <>
                  <Button onClick={handleAddInventory}>+ Add Inventory</Button>
                </>
              )}
            </div>
            <div className="table-wrapper">
              <Table
                tableHeaders={tableHeaders}
                tableData={tableData}
                actionsData={[]}
                tableKeys={tableKeys}
                full
                rowLineColor="light"
                loading={inventoriesLoading}
                errorLoading={inventoriesError?.message?.length > 0}
                onRetry={() => setRetry((prev) => prev + 1)}
                showDropDown
                dropDownOptions={showDropdown()}
                filterInputs={InventoryFilterOptions}
                handleFilter={handleOrderFilter}
                handleSearch={handleSearch}
              />
            </div>
          </div>

          <div className="mid-stats">
            <div className="bar">
              <h2 className="sub-title">Sales</h2>
              <Barchart
                chartData={getBarchartData(
                  inventoryMetrics?.sales_statistics?.monthly_breakdown,
                )}
                options={barOptions}
              />
            </div>
            <div className="short-table">
              <h2 className="sub-title">Recent Orders</h2>
              <Table
                tableHeaders={tableHeadersShort}
                tableData={getRecentOrderTableData(
                  inventoryMetrics?.recent_orders,
                )}
                actionsData={[]}
                tableKeys={tableKeysShort}
                full={false}
                rowLineColor="light"
              />
            </div>
          </div>
        </div>
        <Modal
          title={modalTitle}
          subTitle={modalSubtitle}
          isOpen={showModal}
          close={onCloseModal}
        >
          <ModalWrapper
            short={
              stage === "inventory-preview" ||
              stage === "inventory-view" ||
              stage === "inventory-edit-preview"
            }
          >
            {/* Inventory add form */}
            <ModalFormWrapper show={stage === "inventory"}>
              <DataWrapper
                noDataMessage="No product added yet, Products added will show here."
                loading={productsLoading}
                error={productsError}
                onFailAction={() => setRetry((prev) => prev + 1)}
                loadingMessage="Loading products data..."
                failedMessage="Could not fetch products data. Check your network and click the button below to retry"
              >
                <Form
                  loadingState={false}
                  submitLabel={"Continue"}
                  formInputs={actualInventoryForm}
                  processInputs={onFormContinue}
                  spinnerComponent={"spinner"}
                  login={false}
                  biControl={false}
                  handleBack={undefined}
                  externalUpdateData={handleSingleProduceChange}
                />
              </DataWrapper>
            </ModalFormWrapper>

            <ModalPreviewWrapper show={stage === "inventory-preview"}>
              <Preview
                data={previewData}
                biControl
                onBack={onPreviewBack}
                loading={submitLoading}
                onSubmit={onPreviewSubmit}
              />
            </ModalPreviewWrapper>

            {/* Inventory Edit form */}
            <ModalFormWrapper show={stage === "inventory-edit"}>
              <Form
                loadingState={false}
                submitLabel={"Continue"}
                formInputs={editForm}
                processInputs={onEditInventoryContinue}
                spinnerComponent={"spinner"}
                login={false}
                biControl={false}
                handleBack={undefined}
              />
            </ModalFormWrapper>

            <ModalPreviewWrapper show={stage === "inventory-edit-preview"}>
              <Preview
                data={previewData}
                biControl
                onBack={onEditPreviewBack}
                loading={submitLoading}
                onSubmit={onEditPreviewSubmit}
              />
            </ModalPreviewWrapper>

            <ModalPreviewWrapper show={stage === "inventory-view"}>
              {selectedInventory && (
                <InventoryDetails data={selectedInventory} />
              )}
            </ModalPreviewWrapper>
          </ModalWrapper>
        </Modal>
        {/* *********** Batch uploading section ************ */}
        <Modal
          isOpen={openBatchUpload}
          close={CloseBatuploadModal}
          title={step === "form" ? "Add Inventory" : "Preview Inventory"}
          subTitle={
            step === "form"
              ? "Upload Batch Serialization Data"
              : "Confirm Inventory Details"
          }
        >
          {step === "form" ? (
            /* ===================== FORM STEP ===================== */
            <div className="sm:w-[40rem] w-[20rem]">
              <Form
                loadingState={false}
                formInputs={batchInventoryForm}
                removeSubmitButton
                processInputs={() => {}}
                externalUpdateData={handleExternalUpdate}
              />

              <div className="p-3 m-5">
                <div className="mt-2 mb-2 flex justify-end">
                  <a
                    className="text-sm font-medium text-indigo-600 hover:underline"
                    href="/template/Batch-upload-template.xlsx"
                    download
                  >
                    Download Template
                  </a>
                </div>

                <FileUpload onFileSelect={setSelectedFile} />
              </div>

              <div className="my-5 flex justify-center">
                <Button
                  onClick={() => setStep("preview")}
                  type="button"
                  disabled={!selectedFile || !BatchformData}
                >
                  Continue
                </Button>
              </div>
            </div>
          ) : (
            /* ===================== PREVIEW STEP ===================== */
            <PreviewInventory
              data={selectedProduct}
              filePreview={selectedFile}
              packagingTypes={BatchformData?.package_type}
              onSubmit={onBatchSubmit}
              onBack={() => setStep("form")}
            />
          )}
        </Modal>
      </AddInventoryWrapper>

      <ActionPopup
        position={position}
        open={showInventoryOptions}
        onClose={() => setShowInventoryOptions(false)}
        actions={InvertoryTypeActions}
      />
    </>
  );
}
